// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header.js';
import Splash from './pages/Splash.js';
import Home from './pages/Home.js';
import Posts from './pages/Posts.js';
import Post from './components/Post.js';
import Archive from './pages/Archive.js';
import BackroomsConversation from './components/BackroomsConversation.js';
import Footer from './components/Footer.js';
import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Inner = ({ children }) => (
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-lg-8 col-md-10">
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  </div>
);

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/lurking" element={<Inner><Home /></Inner>} />
        <Route path="/browsing" element={<Inner><Posts /></Inner>} />
        <Route path="/reading/:slug" element={<Inner><Post /></Inner>} />
        <Route path="/archive" element={<Inner><Archive /></Inner>} />
        <Route path="/archive/:tab" element={<Inner><Archive /></Inner>} />
        <Route path="/lurkingIn/:dyad/:slug" element={<Inner><BackroomsConversation /></Inner>} />
      </Routes>
    </Router>
  );
};

export default App;